import { Observable } from 'rxjs'
import { AccountBook } from '../models/account_book.model'
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import myBooksQuery from 'src/app/graphql/queries/my_books.query.graphql'

@Injectable()
export class AccountBookService extends GraphQLService<AccountBook> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    super(http, snackBar);
  }

  myBooks(): Observable<AccountBook[]> {
    return this.findAll(myBooksQuery)
  }

}
